export default __webpack_public_path__ + "static/media/written-quiz.604b935b.png";